import script from "./role-permissions-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./role-permissions-editor.vue?vue&type=script&setup=true&lang=js"

import "./role-permissions-editor.vue?vue&type=style&index=0&id=22eb89d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22eb89d8"]])

export default __exports__